import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    fees_container: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        padding: '16px 0',
        height: 'calc(100vh - 525px)',
        overflow: 'hidden',
    },
    fees_list: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        flex: 1,
        overflowY: 'auto',
        paddingRight: '4px',
    },
    payment_fee_row_container: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: '16px',
        padding: '16px',
        backgroundColor: '#fafafa',
        borderRadius: '8px',
        border: '1px solid #e0e0e0',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: '#f5f5f5',
            borderColor: '#bdbdbd',
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
        },
    },
    payment_type: {
        minWidth: '160px',
        flexShrink: 0,
    },
    range_container: {
        display: 'flex',
        gap: '12px',
        flex: 1,
    },
    range_input: {
        flex: 1,
        minWidth: '120px',
    },
    value_container: {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        minWidth: '180px',
    },
    checkbox_row: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '4px',
    },
    section_header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '16px',
        paddingBottom: '12px',
        borderBottom: '1px solid #e0e0e0',
    },
    section_title: {
        fontSize: '16px',
        fontWeight: 600,
        color: '#333',
    },
    add_button: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        backgroundColor: 'transparent',
        border: '1px dashed #1976d2',
        borderRadius: '8px',
        color: '#1976d2',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        fontSize: '14px',
        fontWeight: 500,
        '&:hover': {
            backgroundColor: 'rgba(25, 118, 210, 0.04)',
            borderStyle: 'solid',
        },
    },
    remove_button: {
        minWidth: '40px',
        height: '40px',
        borderRadius: '8px',
        color: '#757575',
        alignSelf: 'center',
        '&:hover': {
            backgroundColor: 'rgba(244, 67, 54, 0.08)',
            color: '#f44336',
        },
    },
    payment_icon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '36px',
        height: '36px',
        borderRadius: '8px',
        backgroundColor: '#e3f2fd',
        color: '#1976d2',
        marginRight: '8px',
    },
    '@media (max-width: 960px)': {
        payment_fee_row_container: {
            flexDirection: 'column',
            alignItems: 'stretch',
        },
        range_container: {
            flexDirection: 'column',
        },
        payment_type: {
            minWidth: '100%',
        },
        value_container: {
            minWidth: '100%',
        },
    },
    empty_state: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '40px 20px',
        backgroundColor: '#fafafa',
        borderRadius: '8px',
        border: '1px dashed #e0e0e0',
        color: '#757575',
        textAlign: 'center',
    },
    empty_state_text: {
        fontSize: '14px',
        marginBottom: '16px',
    },
    actions_footer: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px',
        marginTop: '24px',
        paddingTop: '16px',
        borderTop: '1px solid #e0e0e0',
    },
    field_label: {
        fontSize: '12px',
        color: '#757575',
        marginBottom: '4px',
        fontWeight: 500,
    },
    field_group: {
        display: 'flex',
        flexDirection: 'column',
    },
}));

export { useStyles };
